import { forwardRef } from 'react';
import { cn } from '../../../lib/cn';

/**
 * BuyBar.
 *
 * CSS selector: `organisms.css .ds-buy-bar` with `__price`, `__meta`.
 *
 * Doctrine:
 *
 * - The pinned bottom commerce bar. It lifts on a HAIRLINE, not a shadow.
 *   Shadows belong to floating layers, and this bar is attached to the page.
 * - The CTA is a slot, composed as `ds-cta ds-cta--solid ds-cta--lg`. Ink, not
 *   accent, and never a gradient. This organism owns the bar chrome and the
 *   price text only, it never re-implements the button.
 * - The price here is the cheapest listing, in RANDS with an `R` prefix. There
 *   is a live dollar sign bug of exactly this kind elsewhere in the app, so the
 *   formatted string is the caller's responsibility and must be checked.
 * - `meta` is muted supporting text such as the condition or the listing count.
 *   It never carries a courier, a city of origin or a shipping price, the app
 *   cannot source those. Shipping is nationwide, full stop.
 * - Above 1024px this does not render. The desktop track uses a sticky buy box
 *   in the right column instead.
 */
export const BuyBar = forwardRef(function BuyBar(
  { className, price, meta, cta, children, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={cn('ds-buy-bar', className)} {...rest}>
      <span>
        <span className="ds-buy-bar__price">{price}</span>
        {meta && <span className="ds-buy-bar__meta">{meta}</span>}
      </span>
      {cta}
      {children}
    </div>
  );
});

export default BuyBar;
